import { NgModule, ModuleWithProviders } from '@angular/core';
import { EventAPIService } from './services/event.service';
import { OrganizationAPIService } from './services/organization.service';
import { QomePublicApiConfiguration, QOME_PUBLIC_API_CONFIGURATION } from './configuration';
import { ContactAPIService } from './public-api';

@NgModule({
    providers: [
        ContactAPIService,
        EventAPIService,
        OrganizationAPIService
    ]
})
export class QomePublicApiModule {
    public static forRoot(): ModuleWithProviders<QomePublicApiModule> {
        return {
            ngModule: QomePublicApiModule,
            providers: [{ provide: QOME_PUBLIC_API_CONFIGURATION, useValue: new QomePublicApiConfiguration() }]
        };
    }
}